// src/components/SessionTimeoutModal.js

import React, { useState, useEffect } from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';

const SessionTimeoutModal = ({ isOpen, onStay, onLogout, countdownSeconds = 60 }) => {
  const [countdown, setCountdown] = useState(countdownSeconds);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(countdownSeconds);
      return;
    }

    const interval = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, countdownSeconds]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-sm w-full text-center">
        <AlertTriangle className="mx-auto text-yellow-500" size={48} />
        <h2 className="text-2xl font-bold mt-4">¿Sigues ahí?</h2>
        <p className="text-gray-600 mt-2">
          Tu sesión se cerrará automáticamente por inactividad.
        </p>
        <p className="text-4xl font-bold my-4 text-red-600">{countdown}</p>
        <p className="text-sm text-gray-500">
          Para proteger tu cuenta, cerraremos la sesión en breve.
        </p>
        <div className="mt-6 space-y-3">
          <button
            onClick={onStay}
            className="w-full px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors"
          >
            Permanecer Conectado
          </button>
          <button
            onClick={onLogout}
            className="w-full flex items-center justify-center px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
          >
            <LogOut className="mr-2" size={16} />
            Cerrar Sesión Ahora
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;